import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import userReferralStatSaga from './sagas/userReferralStatSaga';

export default [
  // Lists
  ...createCombineMapItem('userReferralStatList', createListReduceObject, [
    userReferralStatSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userReferral/reducers/static/lists/reducersMap.js